// import Swiper JS
import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Mousewheel, Parallax, Thumbs, Lazy } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Mousewheel, Parallax, Thumbs, Lazy]);

// import Swiper styles
import 'swiper/swiper-bundle.css';
import { URLASSOLUTO } from './variables';

const swiper = $(document).ready(function () {



    var swipergcounter = false;
    if ($('.swiper-container.swiperg .swiper-slide').length > 1) {
        swipergcounter = true;
    }
    var swiperg = new Swiper('.swiper-container.swiperg', {
        slidesPerView: 2,
        spaceBetween: 10,
        watchOverflow: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
            },
        }
    });


    var swiper1counter = false;
    if ($('.swiper-container.swiper1 .swiper-slide').length > 1) {
        swiper1counter = true;
    }
    var swiper1 = new Swiper('.swiper-container.swiper1', {
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        }
    });

    var swiper2counter = false;
    var swiper2countera = false;
    if ($('.swiper-container.swiper2 .swiper-slide').length > 1) {
        swiper2counter = true;
    }
    if ($('.swiper-container.swiper2 .swiper-slide').length > $('.swiper-container.swiper2 .swiper-slide-visible').length) {
        swiper2countera = true;
    }
    var swiper2 = new Swiper('.swiper-container.swiper2', {
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesVisibility: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
        }
    });

    var swiper3counter = false;
    if ($('.swiper-container.swiper3 .swiper-slide').length > 1) {
        swiper1counter = true;
    }
    var swiper3 = new Swiper('.swiper-container.swiper3', {
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        breakpoints: {
            576: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            992: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        }
    });


    var swiper4counter = false;
    var swiper4countera = false;
    if ($('.swiper-container.swiper4 .swiper-slide').length > 1) {
        swiper4counter = true;
    }
    if ($('.swiper-container.swiper4 .swiper-slide').length > $('.swiper-container.swiper4 .swiper-slide-visible').length) {
        swiper4countera = true;
    }
    var swiper4 = new Swiper('.swiper-container.swiper4', {
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1201: {
                slidesPerView: 5,
            },
        }
    });

    var swiper5counter = false;
    var swiper5countera = false;
    if ($('.swiper-container.swiper5 .swiper-slide').length > 1) {
        swiper5counter = true;
    }
    if ($('.swiper-container.swiper5 .swiper-slide').length > $('.swiper-container.swiper5 .swiper-slide-visible').length) {
        swiper5countera = true;
    }
    var swiper5 = new Swiper('.swiper-container.swiper5', {
        slidesPerView: 2,
        watchOverflow: true,
        watchSlidesVisibility: true,
        navigation: {
            nextEl: ".swiper-button-next.swiper5nav",
            prevEl: ".swiper-button-prev.swiper5nav",
        },
        breakpoints: {
            576: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 6,
            },
        }
    });

    var mySwiper = new Swiper(".mySwiper", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      var mySwiper2 = new Swiper(".mySwiper2", {
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: mySwiper,
        },
      });

      $('body').on('change', 'input[name=tab-control]:radio', function () {
          mySwiper.update();
          mySwiper2.update();
      });

});

export { swiper as default };
